/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Danish (Denmark)
export default {
  'confluence-table-tree.column.contributors': 'Bidragydere',
  'confluence-table-tree.column.last-modified': 'Sidst ændret',
  'confluence-table-tree.column.title': 'Navn',
  'confluence-table-tree.could-not-load': 'Kunne ikke indlæses',
  'confluence-table-tree.could-not-load-contributors': 'Bidragsydere kunne ikke indlæses',
  'confluence-table-tree.create-child-page': 'Opret en underordnet side',
  'confluence-table-tree.create-page': 'Opret side',
  'confluence-table-tree.default.page.title': 'Uden titel',
  'confluence-table-tree.default.show-all-pages-button.label': 'Vis flere sider',
  'confluence-table-tree.draft.lozenge': 'UDKAST',
  'confluence-table-tree.draft.tooltip': 'Udkast kan kun ses af dig.',
  'confluence-table-tree.drafts-toggle.label': 'Vis udkast',
  'confluence-table-tree.edit': 'Rediger',
  'confluence-table-tree.edit-in-confluence': 'Rediger i Confluence',
  'confluence-table-tree.empty.description':
    'Opret mødenoter, produktkrav, beslutninger eller andet indhold for at se området blive fyldt ud.',
  'confluence-table-tree.empty.title': 'Der er ikke andet end potentiale her',
  'confluence-table-tree.error.description': 'Vi kan ikke vise dig disse sider. Prøv igen senere.',
  'confluence-table-tree.error.row': 'Sider kan ikke indlæses.',
  'confluence-table-tree.error.title': 'Ups, det var pinligt ...',
  'confluence-table-tree.friendly-when-created': 'Oprettet',
  'confluence-table-tree.friendly-when-updated': 'Opdateret',
  'confluence-table-tree.share.copied': 'Kopieret til udklipsholderen',
  'confluence-table-tree.share.copy-button': 'Kopiér',
  'confluence-table-tree.share.subtitle': 'Del dette link',
  'confluence-table-tree.share.title': 'Del side',
  'confluence-table-tree.share.tooltip': 'Del',
  'confluence-table-tree.view-profile': 'Se profil',
};
